<template>
  <div class="affiliate-user-detail">
    <div class="white-bg padding-left padding-right padding-top border-radius-top">
      <div class="flex justify-between">
        <div class="text-title">
          {{ $t('affiliate.distributorDetails') }}
        </div>
      </div>

      <!-- 分销员信息 -->
      <div class="margin-top">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('affiliate.distributorId') }}：</label>
              <label>{{ affiliateUserInfo.auId }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('affiliate.ruleName') }}:</label>
              <label>{{ affiliateUserInfo.ruleName }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('affiliate.relatedUserName') }}:</label>
              <label>{{ affiliateUserInfo.userName }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('affiliate.distributorLevel') }}:</label>
              <label>{{ _level(affiliateUserInfo.level) }}</label>
            </div>
          </el-col>

          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('affiliate.totalCommission') }}:</label>
              <label>{{ affiliateUserInfo.totalCommission }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('affiliate.availableCommission') }}:</label>
              <label>{{ affiliateUserInfo.availableCommission }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('affiliate.withdrawnCommission') }}:</label>
              <label>{{ affiliateUserInfo.withdrawnCommission }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('affiliate.teamCount') }}:</label>
              <label>{{ affiliateUserInfo.teamCount }}</label>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="vc-line-primary margin-top"></div>
      
      <div class="margin-top-sm">
        <el-tabs v-model="affiliateUserInfo._currentTab" @tab-click="changeTab">
          <el-tab-pane 
            v-if="affiliateUserInfo.level === '1'" 
            :label="$t('affiliate.secondLevelDistributor')" 
            name="detailAffiliateUser">
          </el-tab-pane>

          <el-tab-pane 
            :label="$t('affiliate.boundUsers')" 
            name="detailAffiliateRelation">
          </el-tab-pane>

          <el-tab-pane 
            :label="$t('affiliate.distributionOrders')" 
            name="detailAffiliateCommission">
          </el-tab-pane>

          <el-tab-pane 
            :label="$t('affiliate.withdrawalRecords')" 
            name="detailAffiliateWithdrawal">
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="white-bg padding-left padding-right padding-top border-radius-bottom">
      <detail-affiliate-user 
        v-if="affiliateUserInfo._currentTab === 'detailAffiliateUser'"
        ref="detailAffiliateUser">
      </detail-affiliate-user>

      <detail-affiliate-relation 
        v-if="affiliateUserInfo._currentTab === 'detailAffiliateRelation'"
        ref="detailAffiliateRelation">
      </detail-affiliate-relation>

      <detail-affiliate-commission 
        v-if="affiliateUserInfo._currentTab === 'detailAffiliateCommission'"
        ref="detailAffiliateCommission">
      </detail-affiliate-commission>

      <detail-affiliate-withdrawal 
        v-if="affiliateUserInfo._currentTab === 'detailAffiliateWithdrawal'"
        ref="detailAffiliateWithdrawal">
      </detail-affiliate-withdrawal>
    </div>
  </div>
</template>

<script>
import { getAffiliateUserDetail } from '@/api/affiliate/affiliateUserApi'
import DetailAffiliateUser from '@/components/affiliate/detailAffiliateUser'
import DetailAffiliateRelation from '@/components/affiliate/detailAffiliateRelation'
import DetailAffiliateCommission from '@/components/affiliate/detailAffiliateCommission'
import DetailAffiliateWithdrawal from '@/components/affiliate/detailAffiliateWithdrawal'

export default {
  name: 'AffiliateUserDetail',
  components: {
    DetailAffiliateUser,
    DetailAffiliateRelation,
    DetailAffiliateCommission,
    DetailAffiliateWithdrawal
  },
  data() {
    return {
      affiliateUserInfo: {
        auId: '',
        ruleId: '',
        ruleName: '',
        userId: '',
        userName: '',
        level: '',
        state: '',
        totalCommission: '',
        availableCommission: '',
        withdrawnCommission: '',
        teamCount: '',
        _currentTab: 'detailAffiliateUser',
      }
    }
  },
  created() {
    this.affiliateUserInfo.auId = this.$route.query.auId
    if (!this.affiliateUserInfo.auId) {
      return
    }
    this._listDetail()
  },
  methods: {
    async _listDetail() {
      try {
        const res = await getAffiliateUserDetail({
          page: 1,
          row: 1,
          auId: this.affiliateUserInfo.auId
        })
        Object.assign(this.affiliateUserInfo, res.data[0])
        this.changeTab(this.affiliateUserInfo._currentTab)
      } catch (error) {
        console.error('获取分销员详情失败:', error)
      }
    },
    changeTab(tab) {
      this.affiliateUserInfo._currentTab = tab
      this.$nextTick(() => {
        if (this.$refs[tab]) {
          this.$refs[tab].loadData({
            auId: this.affiliateUserInfo.auId
          })
        }
      })
    },
    _level(state) {
      if (state === "1") {
        return this.$t('affiliate.firstLevel')
      }
      if (state === "2") {
        return this.$t('affiliate.secondLevel')
      }
      return ''
    },
    _auditState(state) {
      console.log(state)
      if (state === "0") {
        return this.$t('affiliate.pendingReview')
      }
      if (state === "1") {
        return this.$t('affiliate.approved')
      }
      if (state === "2") {
        return this.$t('affiliate.rejected')
      }
      return ''
    }
  }
}
</script>

<style scoped>
.white-bg {
  background: #fff;
}
.padding-left {
  padding-left: 20px;
}
.padding-right {
  padding-right: 20px;
}
.padding-top {
  padding-top: 20px;
}
.border-radius-top {
  border-radius: 4px 4px 0 0;
}
.border-radius-bottom {
  border-radius: 0 0 4px 4px;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.text-title {
  font-size: 18px;
  font-weight: bold;
}
.margin-top {
  margin-top: 20px;
}
.margin-top-sm {
  margin-top: 10px;
}
.vc-line-primary {
  height: 1px;
  background-color: #ebeef5;
}
.form-group {
  margin-bottom: 15px;
}
.col-form-label {
  font-weight: bold;
  margin-right: 10px;
}
</style>